import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#F8F7F5] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/3bf68d6c09283a962d249fcc9ea91526/ab1e605b7823c60e0472793f0d68ad5d.png" 
                alt="BrightSync Logo" 
                className="h-14 w-auto"
              />
              <span className="text-2xl font-bold text-[#1A2332]">BrightSync</span>
            </div>
            <p className="text-[#5A6670] text-sm leading-relaxed">
              Critical parts readiness coordination for data center operations.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-[#1A2332] mb-4">Solutions</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('solution')}
                  className="text-[#5A6670] hover:text-[#0A5F5C] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Readiness Coordination
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('pilot')}
                  className="text-[#5A6670] hover:text-[#0A5F5C] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Pilot Program
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('how-it-works')}
                  className="text-[#5A6670] hover:text-[#0A5F5C] transition-colors cursor-pointer whitespace-nowrap"
                >
                  How It Works
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-[#1A2332] mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('why-brightsync')}
                  className="text-[#5A6670] hover:text-[#0A5F5C] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Why BrightSync
                </button>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-[#5A6670] hover:text-[#0A5F5C] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-[#1A2332] mb-4">Service Area</h4>
            <ul className="space-y-2 text-[#5A6670] text-sm">
              <li>Austin, TX</li>
              <li>Dallas-Fort Worth, TX</li>
              <li>Texas Infrastructure Corridors</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-300 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-[#5A6670] text-sm">
            © 2025 BrightSync. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#5A6670] hover:text-[#0A5F5C] transition-colors text-sm whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
